export default __webpack_public_path__ + "static/media/i.4da3509b.svg";